(function() {
  // Vérifier qu'on est sur une page produit
  const isProductPage = window.location.pathname.includes('/products/') || 
                        document.querySelector('[data-section-type="product"]') ||
                        document.querySelector('.product-template') ||
                        document.body.classList.contains('template-product');
  
  if (!isProductPage) {
    console.log('❌ Script icône désactivé (pas une page produit)');
    return;
  }
  
  console.log('✅ Page produit détectée, activation du script de déplacement d\'icône');
  
  function moveIcon() {
    // Chercher l'icône avec plusieurs sélecteurs possibles
    const icon = document.querySelector('img[src*="icon2.png"]') || 
                 document.querySelector('.icon-block__media') ||
                 document.querySelector('[class*="icon_yjwpem"]');
    
    const textBlock = document.querySelector('[class*="text_gXMUag"]') ||
                      document.querySelector('.text-block--background');
    
    console.log('🔍 Recherche icône:', icon);
    console.log('🔍 Recherche bloc texte:', textBlock);
    
    if (icon && textBlock && !textBlock.contains(icon)) {
      textBlock.appendChild(icon);
      console.log('✅ Icône déplacée avec succès!');
      
      // Appliquer les styles
      icon.style.position = 'absolute';
      icon.style.bottom = '12px';
      icon.style.right = '12px';
      icon.style.width = '30px';
      icon.style.height = '30px';
      icon.style.margin = '0';
      
      textBlock.style.position = 'relative';
      textBlock.style.paddingBottom = '50px';
    } else {
      console.log('❌ Impossible de déplacer l\'icône');
    }
  }

  // Essayer plusieurs fois
  document.addEventListener('DOMContentLoaded', moveIcon);
  setTimeout(moveIcon, 100);
  setTimeout(moveIcon, 500);
  setTimeout(moveIcon, 1000);
  setTimeout(moveIcon, 2000);
})();
